import { render, staticRenderFns } from "./newSchemeDetailsTableImg.vue?vue&type=template&id=26bb7f6a"
import script from "./newSchemeDetailsTableImg.vue?vue&type=script&lang=js"
export * from "./newSchemeDetailsTableImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports